import { SemiTrailerSize } from '../../../fleet/common/enums/semi-trailer-size';

export enum OrderSemiTrailerSize {
  MEGA = SemiTrailerSize.MEGA,
  HALF_MEGA = SemiTrailerSize.HALF_MEGA,
  STANDARD = SemiTrailerSize.STANDARD,
  AUTO = 'auto',
}
